import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Icons } from '../../../../shared/helpers/icons';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { IMaterial } from '../../../../shared/models/materials';

@Component({
  selector: 'materials-equipment-detail',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule
  ],
  templateUrl: './materials-equipment-detail.component.html',
  styleUrl: './materials-equipment-detail.component.css'
})
export class MaterialsEquipmentDetailComponent {
  icons = Icons

  @Input() material: IMaterial | null = null;

  @Output() onClose = new EventEmitter<void>;

  closeModal(): void {
    this.onClose.emit();
  }
}
